export enum FormType {
  LOGIN = 'LOGIN',
  FORGET = 'FORGET',
  RESET = 'RESET',
  AUTH = 'AUTH',
  SUCCESS = 'SUCCESS',
}

export type LoginDataType = {
  identifyId: string
  password: string
}

export type ResetDataType = {
  password: string
  confirmPassword: string
}
